export default "__VITE_ASSET__Bn956ZQV__"